import { render, staticRenderFns } from "./CmgIngredients.vue?vue&type=template&id=19da4776&scoped=true&lang=pug&"
import script from "./cmg-ingredients.ts?vue&type=script&lang=ts&"
export * from "./cmg-ingredients.ts?vue&type=script&lang=ts&"
import style0 from "./CmgIngredients.vue?vue&type=style&index=0&id=19da4776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da4776",
  null
  
)

export default component.exports